import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { faceStar } from "./index";
import { awsUpload } from "./awsUpload";
import { clientError } from "@/api/utils/apiHelper";
import { logEvent } from "./helpers";
/**
 * 相似明星
 * @param base64
 * @param group 后台暂时只支持star
 */
// star - 所有
// model - 模特
// singer - 歌手
// socialMediaStar - 社交媒体明星
// actor - 演员
// athlete - 运动员
// politician - 政治家
// billionaire - 亿万富翁
// historicalFigures - 历史名人

export var celebritiesNew =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(base64) {
    var group,
        deviceInfo,
        deviceId,
        awsUploadResult,
        celebritiesResult,
        meta,
        data,
        matchs,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            group = _args.length > 1 && _args[1] !== undefined ? _args[1] : "star";
            _context.prev = 1;
            deviceInfo = window.device;
            deviceId = deviceInfo.deviceId;
            _context.next = 6;
            return awsUpload(deviceId, base64);

          case 6:
            awsUploadResult = _context.sent;
            _context.next = 9;
            return faceStar(awsUploadResult.data, group);

          case 9:
            celebritiesResult = _context.sent;
            logEvent("req_celebrities_new", celebritiesResult);
            meta = celebritiesResult.meta, data = celebritiesResult.data;

            if (!(meta.code === 200)) {
              _context.next = 21;
              break;
            }

            matchs = data.matchs;

            if (!(matchs.length >= 0)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", matchs);

          case 18:
            return _context.abrupt("return", _Promise.reject(new Error("Empty matches star.")));

          case 19:
            _context.next = 22;
            break;

          case 21:
            return _context.abrupt("return", _Promise.reject(meta.message || new Error("Uncaught Error.")));

          case 22:
            _context.next = 28;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](1);
            clientError("req_celebrities_new", _context.t0);
            return _context.abrupt("return", _Promise.reject(_context.t0));

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 24]]);
  }));

  return function celebritiesNew(_x) {
    return _ref.apply(this, arguments);
  };
}();